import { AssetPublishModel } from 'src/models/assetModel';
import { FC, useEffect, useState } from 'react';
import assetSearchModel from 'src/models/responses/assetSearchModel';
import { ExtendedLicenseModel, StandardLicenseModel } from 'src/models/LicenseModel';
import { AssetType } from 'src/constant/assetConstants';
import { StandardLicense } from 'src/constant/licenseConstants';
import JustifiedGallery from './JustifiedGallery';

interface TypeInterface {
  searchModel: assetSearchModel[];
}

const GallerySearch: FC<TypeInterface> = ({ searchModel }) => {
  const [assets, setAssets] = useState<AssetPublishModel[]>([]);

  useEffect(() => {
    onSetAssetPublishModel();
  }, [searchModel]);

  const onSetAssetPublishModel = () => {
    const datas: AssetPublishModel[] = searchModel.map<AssetPublishModel>((item) => ({
      id: item.id,
      assetType: item.assetType,
      code: item.code!,
      name: item.name,
      description: item.description!,
      thumbnailImageUrl: item.thumbnailImageUrl!,
      thumbnailVideoUrl: item.thumbnailVideoUrl!,
      thumbnailVideoCoverUrl: item.thumbnailVideoCoverUrl!,
      hasSMLicense: item.hasSMLicense,
      hasXLLicense: item.hasXLLicense,
      hasHDLicense: item.hasHDLicense,
      hasUHDLicense: item.hasUHDLicense,
      publishDate: new Date(),
      hasCollection: false,
      keywords: item.keywords!,
      userId: '',
      artistFirstname: item.artistName,
      artistLastname: item.artistName,
      artistNameEn: item.artistNameEn,
      standardLicense: {
        id: 'string',
        assetType: AssetType.IMAGE,
        code: StandardLicense.SM,
        name: 'string',
        price: 0,
        sequence: 0,
      } as StandardLicenseModel,
      extendedLicense: {
        id: 'string',
        assetType: AssetType.IMAGE,
        code: StandardLicense.SM,
        name: 'string',
        price: 0,
        liftTimeType: 0,
        liftTime: 0,
        sequence: 0,
      } as ExtendedLicenseModel,
      price: 0,
      isDisabled: false,
      isHasLicense: false,
      imageOrientation: item.imageOrientation!,
      width: item.width ?? 0,
      height: item.height ?? 0,
      usage: item.usage,
    }));

    setAssets(datas);
  };

  return <JustifiedGallery assets={assets} />;
}

export default GallerySearch;